<template>
  <div class="home-wrapper">
    <div class="global-bg-image" style="background-image: url('/img/BG.jpg')"></div>
    <!-- HERO SECTION -->
    <section class="hero-section">
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <div class="logo-container animate-fade-in">
          <img
              src="https://masticando-cdn.s3.eu-west-1.amazonaws.com/logo-435x435.png"
              alt="Masticando Logo"
              class="hero-logo"
          >
        </div>
        <h1 class="hero-slogan animate-fade-up">
          Masticativi acquistabili esclusivamente da tecnici del settore
        </h1>
        <div class="hero-actions animate-fade-up delay-1">
          <button @click="scrollToProducts" class="cta-btn primary-btn">
            Scopri i prodotti
          </button>
          <router-link to="/info-clienti" class="cta-btn secondary-btn">
            Chiedi ai nostri clienti
          </router-link>
          <router-link to="/eventi" class="text-link">
            Scopri i nostri eventi
          </router-link>
        </div>
      </div>
      

    </section>

    <!-- INTRO SECTION -->
    <section class="section intro-section bg-black-transparent">
      <div class="container">
        <div class="content-container animate-on-scroll">
          <h2 class="section-title">Il supporto educativo che fa la differenza</h2>
          <p class="section-text">
            Scopri la nostra selezione di masticativi naturali, studiati per favorire il benessere, l’equilibrio, l’apprendimento e la riduzione degli indici di stress del cane.
          </p>
          <a href="https://cinopedia.cloud/article/68930bb44477fad0faf7ac44/masticazioni-qualita-non-puzzano" target="_blank" class="highlight-link">
            I nostri prodotti non puzzano! Scopri perché
          </a>
        </div>
      </div>
    </section>

    <!-- NEW PRODUCTS SECTION -->
    <section class="section products-section" v-if="comingSoonProducts && comingSoonProducts.length > 0">
      <div class="container">
        <div class="section-header">
          <h2>Nuovi in Arrivo</h2>
          <div class="header-line"></div>
        </div>
        <div class="product-grid">
          <v-card
              v-for="(product, index) in comingSoonProducts"
              :key="product.id"
              class="product-card glass-card"
              :style="{ animationDelay: `${index * 0.1}s` }"
              @click="$router.push(`/prodotto/${product.id}/${product.slug}`)"
          >
            <div class="product-image-wrapper">
               <v-img :src="product?.img?.formats?.small?.url" :alt="product.name" aspect-ratio="1" class="product-img"></v-img>
            </div>
            <div class="product-info">
              <h3 class="product-title">{{product.name}}</h3>
              <div class="product-abstract" v-html="product.abstract"></div>
            </div>
          </v-card>
        </div>
      </div>
    </section>

    <!-- CATEGORIZED PRODUCTS SECTION -->
    <section class="section products-section" id="products-deck">
      <div class="container">
        <div class="section-header">
          <h2>Prodotti Disponibili</h2>
          <div class="header-line"></div>
        </div>
        
        <div class="categories-container">
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel
                v-for="(products, type) in groupedProducts"
                :key="type"
                class="category-panel"
            >
              <v-expansion-panel-title class="category-header">
                <div class="d-flex align-center w-100 justify-space-between">
                  <div class="category-title">
                     <h3>{{ type || 'Altri Prodotti' }}</h3>
                  </div>
                  <div class="category-meta">
                    <span class="product-badge">{{ products.length }}</span>
                  </div>
                </div>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div class="product-grid pt-5">
                  <v-card
                      v-for="(product, index) in products"
                      :key="product.id"
                      class="product-card glass-card"
                      :style="{ animationDelay: `${index * 0.1}s` }"
                      @click="$router.push(`/prodotto/${product.id}/${product.slug}`)"
                  >
                    <div class="product-image-wrapper">
                      <v-img :src="product?.img?.formats?.small?.url" :alt="product.name" aspect-ratio="1" class="product-img"></v-img>
                      <div class="hover-overlay">
                        <span class="view-details">Vedi Dettagli</span>
                      </div>
                    </div>
                    <div class="product-info">
                      <h3 class="product-title">{{product.name}}</h3>
                      <div class="product-abstract" v-html="product.abstract"></div>
                    </div>
                  </v-card>
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>
    </section>

    <!-- WHY US SECTION -->
    <section class="section why-us-section bg-black-transparent">
      <div class="container">
        <div class="content-container">
          <h2>Perché Masticando?</h2>
          <div class="features-grid">
            <div 
              class="feature-item" 
              v-for="(feature, index) in features" 
              :key="index"
              :style="{ animationDelay: `${index * 0.2}s` }"
            >
              <div class="feature-icon">{{ feature.icon }}</div>
              <h3>{{ feature.title }}</h3>
              <p>{{ feature.text }}</p>
            </div>
          </div>
          
          <div class="manifesto-text">
              <p>Masticando nasce con un obiettivo preciso: offrire ai professionisti del settore cinofilo prodotti funzionali.</p>
              <p>Siamo certi che saprai scegliere il masticativo giusto per ogni caso.</p>
              <h3>Buon lavoro a tutti!</h3>
              <p class="slogan-tag">#EDUCAMASTICANDO</p>
          </div>
        </div>
      </div>
    </section>

    <!-- CONTACT SECTION -->
    <section class="section contact-section">
      <div class="container">
        <div class="glass-panel text-center animate-on-scroll">
          <h2>Contattaci</h2>
          <p>Hai bisogno di informazioni o vuoi scoprire dove acquistare? Siamo qui per aiutarti!</p>
          <a href="mailto:info@masticando.com" class="mail-link">info@masticando.com</a>
          
          <div class="company-details">
            <strong>Masticando di Carella Valentina</strong>
            <span>P.IVA: 03064600343</span>
            <span>Sede: strada Riano n 11/a 43013 Langhirano (PR)</span>
            <span>N. Riconoscimento: ABP7233</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {updateMetaInfo} from "@/middleware/metaUpdater";
import apiService from "@/services/ApiService";

export default {
  name: 'HomeHome',
  data() {
    return {
      products: [],
      comingSoonProducts: [],
      panel: [], // Controls expansion panels, starts empty (closed)
      features: [
        { icon: '🎓', title: 'Per Professionisti', text: "Prodotti funzionali per l'apprendimento e la riduzione dello stress." },
        { icon: '🔬', title: 'Supporto Tecnico', text: "Sviluppati con veterinari comportamentalisti e nutrizionisti." },
        { icon: '🌿', title: '100% Naturali', text: "Artigianali, italiani, senza additivi. Qualità garantita." },
        { icon: '🤝', title: 'Consulenza', text: "Descrizioni dettagliate e consigli per ogni soggetto." }
      ]
    }
  },
  computed: {
    groupedProducts() {
      const grouped = {};
      this.products.forEach(product => {
        const type = product.type || 'Altri';
        if (!grouped[type]) {
          grouped[type] = [];
        }
        grouped[type].push(product);
      });
      // Optional: Sort keys alphabetically or by some priority if needed
      return Object.keys(grouped).sort().reduce(
        (obj, key) => { 
          obj[key] = grouped[key]; 
          return obj;
        }, 
        {}
      );
    },
    metaInfo() {
      return {
        properties: [
          {property: 'og:title', content: "Masticando"},
          {property: 'og:description', content: "Masticando nasce con un obiettivo preciso: offrire ai professionisti del settore cinofilo prodotti funzionali per il processo di apprendimento del cane e per le attività di riduzione degli indici di stress."},
          {property: 'og:image', content: "https://masticando-cdn.s3.eu-west-1.amazonaws.com/logo-435x435.png"},
          {property: 'og:url', content: "https://masticando.com"},
          {property: 'og:type', content: "website"},
        ]
      }
    }
  },
  methods: {
    async getData() {
      try {
        let products = await apiService.getProducts();
        products = products.sort((a, b) => {
          const nameA = a.order ?? 99;
          const nameB = b.order ?? 99;
          return nameA - nameB;
        });
        this.products = products.filter(product => !product.isComingSoon);
        this.comingSoonProducts = products.filter(product => product.isComingSoon);
      } catch (e) {
        console.error(e);
      }
    },
    scrollToProducts() {
      const el = document.getElementById('products-deck');
      if (el) el.scrollIntoView({behavior: 'smooth'});
    }
  },
  async beforeMount() {
    updateMetaInfo(this.metaInfo);
    await this.getData();
  },
  mounted() {
    // Simple Intersection Observer for scroll animations
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.animate-on-scroll, .feature-item, .bg-black-transparent').forEach(el => {
      observer.observe(el);
    });
  },
  created(){
    const fullPath = this.$route.fullPath;
    if(fullPath.includes("#products-deck")){
       setTimeout(() => {
        const el = document.getElementById('products-deck');
        if(el) el.scrollIntoView({behavior: "smooth", block: "start"});
       }, 250);
       this.$router.replace('/');
    }
  }
}
</script>

<style lang="scss">
@import '../style/_variables.scss';

// Utilities
.text-center { text-align: center; }

// Wrappers
.home-wrapper {
  background-color: $background-color;
  color: $text-color;
  width: 100%;
  overflow-x: hidden;
  position: relative;
}

// GLOBAL BACKGROUND
.global-bg-image {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  z-index: 0;
  opacity: 0.4;
  background-size: cover;
  background-position: center;
  filter: brightness(0.7);
  pointer-events: none;
}

// HERO SECTION
.hero-section {
  position: relative;
  height: 100dvh; // Full viewport height
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 2rem;
  
  // Full width break-out
  width: 100vw;
  margin-left: calc(50% - 50vw);
  
  .hero-overlay {
    // Removed specific overlay to let global BG show for now, or just keep gradient
    position: absolute;
    top: 0; left: 0; width: 100%; height: 100%;
    background: radial-gradient(circle at center, rgba($secondary-color, 0.1) 0%, rgba($background-color, 0.0) 70%); 
    z-index: 1;
  }

  .hero-content {
    position: relative;
    z-index: 2;
    text-align: center;
    max-width: 800px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
  
  .hero-logo {
    width: 300px;
    height: auto;
    filter: drop-shadow(0 0 20px rgba($primary-color, 0.5));
    transition: transform 0.3s ease;
    &:hover { transform: scale(1.05); }
  }
  
  .hero-slogan {
    font-family: $header-font;
    font-size: 2.5rem;
    line-height: 1.2;
    font-weight: 700;
    text-transform: uppercase;
    background: $primary-gradient;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin: 1rem 0;
    
    @media (max-width: 600px) {
      font-size: 1.8rem;
    }
  }
  
  .hero-actions {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    
    .cta-btn {
      padding: 12px 30px;
      border-radius: 50px;
      font-family: $header-font;
      font-weight: 700;
      text-transform: uppercase;
      font-size: 1rem;
      cursor: pointer;
      transition: all 0.3s ease;
      text-decoration: none;
      
      &.primary-btn {
        background: $primary-gradient;
        color: white;
        border: none;
        box-shadow: 0 4px 15px rgba($primary-color, 0.4);
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba($primary-color, 0.6);
        }
      }
      
      &.secondary-btn {
        background: transparent;
        color: $text-color;
        border: 2px solid $secondary-color;
        &:hover {
          background: rgba($secondary-color, 0.1);
        }
      }
    }
    
    .text-link {
      display: block;
      width: 100%;
      margin-top: 10px;
      color: #ccc;
      text-decoration: underline;
      font-size: 0.9rem;
      &:hover { color: white; }
    }
  }
}

// SECTIONS GENERAL
.section {
  padding: 3rem 1rem; // Reduced from 4rem
  position: relative;
  width: 100%; // Full width
  z-index: 1;
  // background-color: rgba(0, 0, 0, 0.85); // REMOVED DEFAULT BG
  margin-bottom: 1rem; // Reduced from 2rem
  
  &.bg-black-transparent {
    // Transparent primary gradient (approximate rgba of #EF6C00 and #f5540c)
    background: linear-gradient(90deg, rgba(239, 108, 0, 0.85) 0%, rgba(245, 84, 12, 0.85) 100%);
    
    // Override text colors for readiness properties on orange background
    h2, h3, .section-title, .feature-icon, .manifesto-text p {
      color: white !important;
      text-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
    p, .section-text, .manifesto-text {
      color: white !important;
    }

    // Animation Init
    opacity: 0;
    
    &.in-view {
      animation: fadeInLeft 1s ease forwards;
    }
  }
  
  .container {
     max-width: 1280px;
     margin: 0 auto;
     width: 100%;
     padding: 0 1rem;
  }
  
  .section-header {
    text-align: center;
    margin-bottom: 1.5rem; // Reduced from 3rem
  
    h2 {
      font-family: $header-font;
      font-size: 2rem;
      text-transform: uppercase;
      margin-bottom: 0.5rem;
    }
    .header-line {
      width: 60px;
      height: 4px;
      background: $primary-gradient;
      margin: 0 auto;
      border-radius: 2px;
    }
  }
}

// INTRO SECTION
.intro-section {
  text-align: center;
  .content-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    border-radius: 10px;
  }
  .section-title {
    font-size: 1.8rem;
    margin-bottom: 1rem; // Reduced from 1.5rem
    color: $primary-color;
  }
  .section-text {
    font-size: 1.1rem;
    line-height: 1.4;
    margin-bottom: 1rem; // Reduced from 1.5rem
    color: #dedede;
  }
  .highlight-link {
    font-weight: bold;
    font-size: 1.1rem;
    text-decoration: underline;
    transition: color 0.3s;
    &:hover { color: lighten($secondary-color, 15%); }
  }
}

// PRODUCT CATEGORIES
.categories-container {
  display: flex;
  flex-direction: column;
  gap: 1rem; // Spacing between category cards

  .v-expansion-panel {
    background: rgba(0, 0, 0, 0.6) !important; // Card-like background
    border: 1px solid rgba(255, 255, 255, 0.1);
    
    &.category-panel {
      border-left: 4px solid $secondary-color; 
      border-radius: 8px !important;
      overflow: hidden;
      box-shadow: 0 4px 6px rgba(0,0,0,0.3);
      transition: all 0.3s ease;
      
      &::before { box-shadow: none; opacity: 0; }
      
      &:hover {
         transform: translateY(-2px);
         box-shadow: 0 8px 16px rgba(0,0,0,0.5);
         background: rgba(0, 0, 0, 0.8) !important; // Darker on hover
      }
      
      &.v-expansion-panel--active {
         background: rgba(0, 0, 0, 0.85) !important; // Full opacity when active
         margin-top: 20px;
         margin-bottom: 20px;
         transform: scale(1.01); // Slight pop
      }
    }
    
    .category-header {
      padding: 1.5rem 2rem;
      border-radius: 0;
      
      .category-title h3 {
         margin: 0;
         color: $text-color;
         font-size: 1.5rem;
         font-weight: 700;
         letter-spacing: 0.5px;
         text-transform: uppercase;
      }
      
      .category-meta {
         .product-badge {
            background: $secondary-color;
            color: white;
            padding: 4px 12px;
            border-radius: 12px;
            font-size: 0.9rem;
            font-weight: bold;
         }
      }
    }
    
    .v-expansion-panel-content__wrap {
      padding: 2rem 1rem;
    }
  }
}

// PRODUCT GRID
.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 2rem;
  padding: 0 0.5rem;
}

.product-card {
  cursor: pointer;
  background: rgba(255, 255, 255, 0.03) !important; // Glass effect
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
  border-radius: 12px !important;
  overflow: hidden;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0,0,0,0.5);
    background: rgba(255, 255, 255, 0.05) !important;
    .hover-overlay { opacity: 1; }
  .product-img { transform: scale(1.05); }
    .product-title { color: $primary-color; }
  }
  
  // Animation
  animation: flipIn 0.6s cubic-bezier(0.4, 0, 0.2, 1) backwards;
  
  .product-image-wrapper {
    position: relative;
    overflow: hidden;
    .product-img {
       transition: transform 0.5s ease;
    }
    .hover-overlay {
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background: rgba(0,0,0,0.6);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.3s ease;
      .view-details {
        color: white;
        border: 1px solid white;
        padding: 8px 16px;
        border-radius: 20px;
        font-family: $header-font;
      }
    }
  }
  
  .product-info {
    padding: 1.5rem;
    .product-title {
      font-family: $header-font;
      font-size: 1.2rem;
      margin-bottom: 0.5rem;
      transition: color 0.3s;
      color: $text-color;
    }
    .product-abstract {
      font-size: 0.9rem;
      color: #aaa;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}

// WHY US
.why-us-section {
  background: rgba($secondary-background-color, 0.5);
  .features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1.5rem; // Reduced from 2rem
    margin: 2rem 0; // Reduced from 3rem
  }
  .feature-item {
    text-align: center;
    padding: 1.5rem;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.75);
    background: rgba(0, 0, 0, 0.75);
    opacity: 0; // Start hidden
    
    &.in-view {
      // Use the flipIn animation
      animation: flipIn 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;
    }
    
    .feature-icon {
      font-size: 2.5rem;
      margin-bottom: 1rem;
    }
    h3 { color: $primary-color; margin-bottom: 0.5rem; }
    p { font-size: 0.9rem; color: #ccc; }
  }
  
  .manifesto-text {
    text-align: center;
    max-width: 800px;
    margin: 2rem auto 0; // Reduced from 3rem
    font-size: 1rem;
    color: #ddd;
    
    h3 {
      font-size: 1.5rem;
      color: $primary-color;
      margin: 1.5rem 0;
    }
    
    .slogan-tag {
      font-family: $header-font;
      font-size: 1.5rem;
      font-weight: bold;
      letter-spacing: 2px;
      color: white;
    }
  }
}

// CONTACT
.contact-section {
  .glass-panel {
    background: rgba(0,0,0,0.85);
    padding: 3rem;
    border-radius: 15px;
    margin: 0 auto;
    
    // Animation Init
    opacity: 0;
    
    &.in-view {
       animation: flipIn 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;
    }
    
    .mail-link {
        display: inline-block;
        margin: 1rem 0 2rem;
        font-size: 1.2rem;
        color: $primary-color;
        font-weight: bold;
        text-decoration: none;
        &:hover { text-decoration: underline; }
    }
    
    .company-details {
      border-top: 1px solid rgba(255,255,255,0.1);
      padding-top: 1.5rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      font-size: 0.9rem;
      color: #888;
      strong { color: #bbb; }
    }
  }
}

// ANIMATIONS
.animate-fade-in { animation: fadeIn 1.5s ease forwards; }
.animate-fade-up { 
  opacity: 0;
  animation: fadeUp 1s ease forwards; 
}
.delay-1 { animation-delay: 0.3s; }

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
@keyframes fadeUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes flipIn {
  0% {
    opacity: 0;
    transform: perspective(1000px) rotateX(-30deg);
  }
  100% {
    opacity: 1;
    transform: perspective(1000px) rotateX(0deg);
  }
}

@keyframes fadeInLeft {
  from { opacity: 0; transform: translateX(-50px); }
  to { opacity: 1; transform: translateX(0); }
}

// Mobile Optimizations
@media (max-width: 600px) {
  // Maximize width for product sections
  .section.products-section {
    padding: 2rem 0; 
    
    .container {
      padding: 0; // Remove container padding
    }
  }
  
  .categories-container {
    .v-expansion-panel-content__wrap {
      padding: 1rem 0; // Remove panel content padding
    }
    
    .category-header {
      padding: 1rem; // Reduce header padding
    }
  }
  
  .product-grid {
    padding: 0; // Remove grid padding
    gap: 1rem; // Tighter gap
  }
}
</style>
